export default __webpack_public_path__ + "static/media/karmayogi-volunteer-pac.aa571d82.jpeg";